var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.685 16a1 1 0 0 1-.6-.205 1.09 1.09 0 0 1-.38-1.135l1.16-4.5-3.5-2.945A1.095 1.095 0 0 1 .05 6.03a1 1 0 0 1 .915-.735l4.5-.24L7.065.68a1 1 0 0 1 1.895 0l1.61 4.375 4.5.24a1.035 1.035 0 0 1 .915.735 1.1 1.1 0 0 1-.33 1.16l-3.5 2.94 1.165 4.5a1.09 1.09 0 0 1-.385 1.135 1 1 0 0 1-1.15.035L8 13.265l-3.76 2.56a1 1 0 0 1-.555.175",
    clipRule: "evenodd"
  })));
};
export default SvgStarFilled;